import React from "react";
import { ArrowRight } from "lucide-react";
import { DIFFERENCE_CARDS } from "../../data/mock";

export default function Difference() {
  return (
    <section className="bg-cream grain px-5 md:px-8 py-20 lg:py-28">
      <div className="max-w-[1240px] mx-auto text-center">
        <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-teal">
          03 <span className="text-navy/40">—</span> The difference
        </p>
        <h2 className="mt-5 mx-auto max-w-3xl font-grotesk font-bold leading-[1.02] tracking-tight text-[clamp(2.25rem,5vw,4rem)]">
          <span className="text-navy">Responsive without</span>{" "}
          <span className="text-teal italic">feeling robotic.</span>
        </h2>
        <p className="mt-6 mx-auto max-w-xl text-navy/70 text-lg leading-relaxed">
          The service is shaped around your business—from the questions callers hear to the priorities your team uses.
        </p>
      </div>

      <div className="max-w-[1240px] mx-auto mt-14 grid md:grid-cols-3 gap-5">
        {DIFFERENCE_CARDS.map((c, i) => (
          <div
            key={i}
            className="group bg-white rounded-3xl border border-navy/8 p-8 flex flex-col hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
          >
            <h3 className="font-grotesk text-xl font-semibold text-navy leading-snug">{c.title}</h3>
            <p className="mt-3 text-navy/60 leading-relaxed flex-1">{c.body}</p>
            <a
              href="#contact"
              className="group/link mt-6 inline-flex items-center gap-2 text-teal font-medium text-[15px]"
            >
              {c.link}
              <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" />
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
